import { Cookies, getCookieConsentValue } from "react-cookie-consent";
import { Route, Routes } from "react-router-dom";
import CookieAccept from "./components/page_subcomponents/cookieconsent";
import { PageLayout } from "./components/PageLayout";
import { useParentBridge } from "./hooks/useParentBridge";
import { ComplaintChecker } from "./pages/ComplaintChecker";
import LandingPage from "./pages/LandingPage";
import { NegativePathway } from "./pages/NegativePathway";
import { useEffect } from "react";

const Pages = () => {
  const { postToParent, addHandler } = useParentBridge();
  useEffect(() => {
    const off = addHandler((msg, parentOrigin) => {
      console.log("Child received:", msg, "from", parentOrigin);
      if (msg.type === "HANDSHAKE_ACKNOWLEDGEMENT") {
        console.log("Handshake completed: parent acknowledged");
      }
    });

    return off;
  }, [addHandler, postToParent]);

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/complaint-checker" element={<ComplaintChecker />} />
      <Route path="/cannot-help" element={<NegativePathway />} />
    </Routes>
  );
};

const App = () => {
  if (getCookieConsentValue() === "false" || !getCookieConsentValue()) {
    Cookies.remove("_ga");
    Cookies.remove("_ga_3N506CR6PZ");
    Cookies.remove("VstsSession");
    Cookies.remove("SpsAuthenticatedUser");
    Cookies.remove("st-last-access-token-update");
  }

  return (
    <PageLayout>
      <CookieAccept />
      <Pages />
    </PageLayout>
  );
};

export default App;
